module.exports = __webpack_public_path__ + "img/zanwu.0c84cc79.png";